import {Component, Inject, OnInit} from '@angular/core';
import {StatusActionType} from "../../common/models/status-action-type.enum";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-action-question',
  templateUrl: './action-question.component.html',
  styleUrls: ['./action-question.component.scss']
})
export class ActionQuestionComponent implements OnInit {

  public statusActionsType = StatusActionType;

  constructor(public dialogRef: MatDialogRef<ActionQuestionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
